var map = {
	"./App": 90343,
	"./App.vue": 90343,
	"./assets/css/global.scss": 24968,
	"./assets/css/loading.scss": 37505,
	"./assets/css/reset.scss": 68726,
	"./assets/css/utils.scss": 51240,
	"./assets/css/viewCss/index.scss": 78426,
	"./assets/fonts/ARIALN.TTF": 51251,
	"./assets/fonts/ARIALNB.TTF": 16011,
	"./assets/fonts/ARIALNBI.TTF": 89324,
	"./assets/fonts/ARIALNI.TTF": 59188,
	"./assets/fonts/Arial-Black-Italic.ttf": 49366,
	"./assets/fonts/Inter-VariableFont_slnt,wght.ttf": 18120,
	"./assets/fonts/Poppins-Bold.ttf": 85717,
	"./assets/fonts/arial.ttf": 25615,
	"./assets/fonts/arialbd.ttf": 61033,
	"./assets/fonts/arialbi.ttf": 43672,
	"./assets/fonts/ariali.ttf": 14680,
	"./assets/fonts/ariblk.ttf": 54789,
	"./assets/fonts/font.css": 60912,
	"./assets/icons": 23582,
	"./assets/icons/": 23582,
	"./assets/icons/index": 23582,
	"./assets/icons/index.js": 23582,
	"./assets/icons/svg/icon-arrow.svg": 95361,
	"./assets/icons/svg/icon-arrow1.svg": 52594,
	"./assets/icons/svg/icon-arrow2.svg": 41281,
	"./assets/icons/svg/icon-close-invite.svg": 66416,
	"./assets/icons/svg/icon-close.svg": 15686,
	"./assets/icons/svg/icon-copy.svg": 38385,
	"./assets/icons/svg/icon-lfg.svg": 4015,
	"./assets/icons/svg/icon-refresh.svg": 30303,
	"./assets/icons/svg/icon-telegram.svg": 29611,
	"./assets/icons/svg/icon-twitter.svg": 74731,
	"./assets/icons/svg/icon-vector.svg": 89295,
	"./assets/icons/svg/icon-vector1.svg": 31340,
	"./assets/icons/svg/icon-vector2.svg": 10367,
	"./assets/images/Mask group.png": 84746,
	"./assets/images/b.png": 1329,
	"./assets/images/b_bar.png": 25295,
	"./assets/images/bg.jpg": 45150,
	"./assets/images/footer-logo.png": 54716,
	"./assets/images/footer.png": 6730,
	"./assets/images/icon-add.svg": 86874,
	"./assets/images/icon-sub.svg": 30413,
	"./assets/images/icon-vector.png": 86674,
	"./assets/images/icon-vector1.png": 529,
	"./assets/images/icon-vector2.png": 75866,
	"./assets/images/logo.png": 82806,
	"./assets/images/logo1.png": 22861,
	"./assets/images/logo3.png": 5823,
	"./assets/images/nav-item-bg.png": 36216,
	"./assets/images/nav-vector.png": 28622,
	"./assets/images/node-bg.png": 98591,
	"./assets/images/p1-bg.png": 77436,
	"./assets/images/p1-img-1.png": 55870,
	"./assets/images/p1-img-bg.png": 31038,
	"./assets/images/p1-intro-bg.png": 68503,
	"./assets/images/p1-intro-bot-bg.png": 80667,
	"./assets/images/p1-intro-tit-bg.png": 74859,
	"./assets/images/p1-intro-tit-line.png": 30836,
	"./assets/images/p1-q1.png": 80523,
	"./assets/images/p1-q2.png": 15120,
	"./assets/images/p1-q3.png": 30873,
	"./assets/images/p2-bg.png": 4197,
	"./assets/images/p2-cv2-bg.png": 59493,
	"./assets/images/p2-cv2-icon-1.png": 29457,
	"./assets/images/p2-cv2-icon-2.png": 53210,
	"./assets/images/p2-cv2-icon-3.png": 43043,
	"./assets/images/p2-cv2-icon-4.png": 93644,
	"./assets/images/p2-cv2-icon-5.png": 5269,
	"./assets/images/p2-cv2-icon-6.png": 84894,
	"./assets/images/p2-img-1.png": 67965,
	"./assets/images/p2-img-2.png": 86758,
	"./assets/images/p2-img-3.png": 25775,
	"./assets/images/p2-img-4.png": 29904,
	"./assets/images/p2-img-bg.png": 18315,
	"./assets/images/p3-head-bg.png": 90061,
	"./assets/images/p3-img-3-ad.png": 14750,
	"./assets/images/p3-img-4-ad-11.png": 33688,
	"./assets/images/p3-img-4-ad.png": 18723,
	"./assets/images/p3-item-bg.png": 93268,
	"./assets/images/p5-bg.png": 40232,
	"./assets/images/roadmap-point.png": 62854,
	"./assets/images/s2-icon-1.png": 23938,
	"./assets/images/s2-icon-2.png": 37945,
	"./assets/images/s2-icon-3.png": 5840,
	"./assets/images/s2-icon-4.png": 18063,
	"./assets/images/threeStar.png": 4859,
	"./assets/images/video.mp4": 18450,
	"./assets/images/wap/p1-intro-bot-bg.png": 48434,
	"./assets/images/wap/p2-bg.png": 74156,
	"./assets/images/wap/p2-img-3.png": 14364,
	"./assets/images/wap/p3-bg.png": 59947,
	"./assets/images/wap/p3-img-3-ad.png": 71919,
	"./assets/images/wap/p3-img-4-ad.png": 39906,
	"./assets/js/noZoom": 48027,
	"./assets/js/noZoom.js": 48027,
	"./assets/js/rem": 23743,
	"./assets/js/rem.js": 23743,
	"./assets/json/particlesP1": 95728,
	"./assets/json/particlesP1.json": 95728,
	"./assets/json/particlesP2": 51245,
	"./assets/json/particlesP2.json": 51245,
	"./assets/json/particlesP3": 54562,
	"./assets/json/particlesP3.json": 54562,
	"./components/AutoBursh": 29720,
	"./components/AutoBursh.vue": 29720,
	"./components/ButtonType1": 48010,
	"./components/ButtonType1.vue": 48010,
	"./components/ChangeLanguageButton": 78621,
	"./components/ChangeLanguageButton.vue": 78621,
	"./components/ComputeView": 81366,
	"./components/ComputeView.vue": 81366,
	"./components/InviteBindingDialog": 54711,
	"./components/InviteBindingDialog.vue": 54711,
	"./components/LayoutCenter": 25015,
	"./components/LayoutCenter.vue": 25015,
	"./components/LevelContentItemView": 97284,
	"./components/LevelContentItemView.vue": 97284,
	"./components/NodeRecord": 717,
	"./components/NodeRecord.vue": 717,
	"./components/ReferralDetailView": 43088,
	"./components/ReferralDetailView.vue": 43088,
	"./components/StakeRecord": 24776,
	"./components/StakeRecord.vue": 24776,
	"./components/StakeView": 9174,
	"./components/StakeView.vue": 9174,
	"./components/TotalOverview": 40319,
	"./components/TotalOverview.vue": 40319,
	"./components/layout": 50704,
	"./components/layout.vue": 50704,
	"./components/myPagination": 43783,
	"./components/myPagination.vue": 43783,
	"./components/mySwiper": 61873,
	"./components/mySwiper.vue": 61873,
	"./components/popClaimOrders": 50116,
	"./components/popClaimOrders.vue": 50116,
	"./components/popDialog": 97225,
	"./components/popDialog.vue": 97225,
	"./components/popPrompt": 60732,
	"./components/popPrompt.vue": 60732,
	"./components/popPromptCompute": 31504,
	"./components/popPromptCompute.vue": 31504,
	"./components/popPromptTwo": 54096,
	"./components/popPromptTwo.vue": 54096,
	"./components/subItem": 10648,
	"./components/subItem.vue": 10648,
	"./components/svgIcon": 55801,
	"./components/svgIcon.vue": 55801,
	"./config": 32176,
	"./config/": 32176,
	"./config/index": 32176,
	"./config/index.js": 32176,
	"./directive": 53215,
	"./directive/": 53215,
	"./directive/direct/v-anchor": 16065,
	"./directive/direct/v-anchor.js": 16065,
	"./directive/direct/v-copy": 11201,
	"./directive/direct/v-copy.js": 11201,
	"./directive/direct/v-debounce": 39483,
	"./directive/direct/v-debounce.js": 39483,
	"./directive/direct/v-draggable": 8389,
	"./directive/direct/v-draggable.js": 8389,
	"./directive/direct/v-scroll": 75425,
	"./directive/direct/v-scroll.js": 75425,
	"./directive/direct/v-shuibowen": 18266,
	"./directive/direct/v-shuibowen.js": 18266,
	"./directive/index": 53215,
	"./directive/index.js": 53215,
	"./http": 48394,
	"./http/": 48394,
	"./http/index": 48394,
	"./http/index.js": 48394,
	"./i18n": 27474,
	"./i18n/": 27474,
	"./i18n/i18nOption": 90923,
	"./i18n/i18nOption.json": 90923,
	"./i18n/index": 27474,
	"./i18n/index.js": 27474,
	"./i18n/json/Chs": 77727,
	"./i18n/json/Chs.json": 77727,
	"./i18n/json/En": 31462,
	"./i18n/json/En.json": 31462,
	"./i18n/json/Jp": 82759,
	"./i18n/json/Jp.json": 82759,
	"./i18n/json/Kr": 99408,
	"./i18n/json/Kr.json": 99408,
	"./i18n/json/Vnm": 20656,
	"./i18n/json/Vnm.json": 20656,
	"./main": 14468,
	"./main.js": 14468,
	"./mixins": 90060,
	"./mixins/": 90060,
	"./mixins/index": 90060,
	"./mixins/index.js": 90060,
	"./router": 16915,
	"./router/": 16915,
	"./router/index": 16915,
	"./router/index.js": 16915,
	"./store": 25507,
	"./store/": 25507,
	"./store/index": 25507,
	"./store/index.js": 25507,
	"./store/modules/claim": 20033,
	"./store/modules/claim.js": 20033,
	"./store/modules/node": 98473,
	"./store/modules/node.js": 98473,
	"./store/modules/private": 17754,
	"./store/modules/private.js": 17754,
	"./store/modules/purchase": 23106,
	"./store/modules/purchase.js": 23106,
	"./store/modules/server": 43822,
	"./store/modules/server.js": 43822,
	"./store/modules/stake": 57847,
	"./store/modules/stake.js": 57847,
	"./store/modules/stakeRecord": 98166,
	"./store/modules/stakeRecord.js": 98166,
	"./store/modules/wallet": 44664,
	"./store/modules/wallet.js": 44664,
	"./utils": 32839,
	"./utils/": 32839,
	"./utils/errcode": 77021,
	"./utils/errcode.js": 77021,
	"./utils/formatter": 2501,
	"./utils/formatter.js": 2501,
	"./utils/index": 32839,
	"./utils/index.js": 32839,
	"./view": 83519,
	"./view/": 83519,
	"./view/index": 83519,
	"./view/index.1": 65934,
	"./view/index.1.vue": 65934,
	"./view/index.vue": 83519,
	"./view/manage": 58544,
	"./view/manage.vue": 58544,
	"./view/pri.1": 49599,
	"./view/pri.1.vue": 49599,
	"./web3Wallet": 88320,
	"./web3Wallet/": 88320,
	"./web3Wallet/config/config": 2561,
	"./web3Wallet/config/config.json": 2561,
	"./web3Wallet/config_for_test/config": 97590,
	"./web3Wallet/config_for_test/config.json": 97590,
	"./web3Wallet/contracts/coinStake": 57637,
	"./web3Wallet/contracts/coinStake.json": 57637,
	"./web3Wallet/contracts/mint": 88520,
	"./web3Wallet/contracts/mint.json": 88520,
	"./web3Wallet/contracts/nft": 90360,
	"./web3Wallet/contracts/nft.json": 90360,
	"./web3Wallet/contracts/privateMint": 79371,
	"./web3Wallet/contracts/privateMint.json": 79371,
	"./web3Wallet/contracts/stakeClaim": 20090,
	"./web3Wallet/contracts/stakeClaim.json": 20090,
	"./web3Wallet/contracts/token": 95713,
	"./web3Wallet/contracts/token.json": 95713,
	"./web3Wallet/contracts_for_test/coinStake": 47766,
	"./web3Wallet/contracts_for_test/coinStake.json": 47766,
	"./web3Wallet/contracts_for_test/mint": 12713,
	"./web3Wallet/contracts_for_test/mint.json": 12713,
	"./web3Wallet/contracts_for_test/nft": 54255,
	"./web3Wallet/contracts_for_test/nft.json": 54255,
	"./web3Wallet/contracts_for_test/privateMint": 8560,
	"./web3Wallet/contracts_for_test/privateMint.json": 8560,
	"./web3Wallet/contracts_for_test/stakeClaim": 45335,
	"./web3Wallet/contracts_for_test/stakeClaim.json": 45335,
	"./web3Wallet/contracts_for_test/token": 10930,
	"./web3Wallet/contracts_for_test/token.json": 10930,
	"./web3Wallet/index": 88320,
	"./web3Wallet/index.js": 88320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;